module.exports = __webpack_public_path__ + "img/ic-prev-active.5be981c8.svg";